import { render, staticRenderFns } from "./bInsuranceShow.vue?vue&type=template&id=7c76bea8"
import script from "./bInsuranceShow.vue?vue&type=script&lang=js"
export * from "./bInsuranceShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports